import Translatable from '@/components/translatable_text/Translatable';
import {
  Typography,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Stack,
} from '@mui/material';
import { ApplicationItem, JobApplicationProps } from '@/types/admin_types';
import ApplicationRow from './ApplicationRow';

const tableHeadList = [
  { id: 231, title: '#', color: '', width: 100 },
  { id: 232, title: 'Name', color: '', width: 150 },
  { id: 233, title: 'Application Type', color: '', width: 150 },
  { id: 234, title: 'Email', color: '', width: 150 },
  { id: 235, title: 'Nationality', color: '', width: 150 },
  { id: 236, title: 'Status', color: '', width: 150 },
  { id: 237, title: 'Action', color: '', width: 150 },
]

type Props = {
  data: JobApplicationProps
}

export default function JobApplicationTable({
  data
}: Props) {

  return (
    <div className='border rounded-md'>
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              {tableHeadList.map((elList) => (
                <TableCell key={elList.id} width={elList.width}>
                  <Stack spacing={2} direction="row">
                    <Typography variant="h6" color='#64758b' fontSize={16}>
                      <Translatable>
                        {elList.title}
                      </Translatable>
                    </Typography>
                  </Stack>
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {data?.items?.map((el: ApplicationItem, index: number) => (
              <ApplicationRow el={el} key={el.id} index={index}/>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </div>
  )
}
